

























































































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from "@/enums/PermissionValue";
import { RowTable } from "@/typings/BRowTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import BaseVue from "../../core/BaseVue";
import UserService from "@/services/user.service";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import PorposalService from "@/services/porposal.service";
import PorposalUserReportEvaluations from "../../models/porposal/porposalUserReportEvaluations.model";
import { ReportEvaluationState } from "@/enums/ReportEvaluationState";
import fileService from "@/services/file.service";
import PorposalDetail from "@/components/porposal-detail-component/detail.vue";
import AnalyticalMatrixEvaluation from '@/models/analyticalMatrixEvaluation.model';
import ProposalUserReportService from '@/services/proposalUserReport.service';
import EspecificObjective from '@/models/porposal/especificObjective.model';
@Component({
  components: {
    ResearchCenterBasicInformationComponent,
    PorposalDetail
  }
})
export default class PorposalReportEvaluation extends BaseVue {
  private loading: boolean = false;
  private showModal: boolean = false;
  private porposalRepository: PorposalService = new PorposalService();
  private proposalUserReportService: ProposalUserReportService = new ProposalUserReportService();
  private model: PorposalUserReportEvaluations = null;

  private state: ReportEvaluationState = null;
  private pendiente: ReportEvaluationState = ReportEvaluationState.Pendiente;
  private aprobado: ReportEvaluationState = ReportEvaluationState.Aprobado;
  private noAprobado: ReportEvaluationState = ReportEvaluationState.NoAprobado;
  private achievedGoals: EspecificObjective[] = [];
  canSendEvaluation: boolean = false;

  goToTable() {
    this.$router.push('/proposal/pendingReports/evaluations');
  }

  setObjetivosAlcanzados(goals: EspecificObjective[]) {
    this.achievedGoals = goals;
    if (this.achievedGoals.length > 0 && !this.achievedGoals.some(x => x.evaluationModelUI.state == this.pendiente)) 
      this.canSendEvaluation = true;
  }

  async created() {
    if (this.$route.params.rid) {
      this.loading = true;
      let id = Number(this.$route.params.rid);
      this.model = await this.porposalRepository.getPorposalUserReportEvaluationById(
        id
      );
      this.state = this.model.state;
      this.loading = false;
    }
  }

  async verDocument(data: any = null, isProjectEndDocument: boolean) {
    if (isProjectEndDocument) {
      if (data.projectEndDocument.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.projectEndDocument.id,
          data.projectEndDocument.originalName
        );
      else await fileService.download(data.projectEndDocument.id);
    } else {
      if (data.document.contentType == "application/octet-stream")
        await fileService.downloadOctetFile(
          data.document.id,
          data.document.originalName
        );
      else await fileService.download(data.document.id);
    }
  }

  async save() {
    if (this.model.description && this.state) {
      this.showModal = false;
      this.loading = true;
      this.model.state = this.state;
      await this.porposalRepository.updatePorposalUserReportEvaluation(
        this.model.id,
        this.model
      );
      this.operationSuccess("Se ha guardado su evaluación de manera exitosa!");
      this.loading = false;
    } else this.operationNoAllowed("Debe llenar todos los campos");
  }

  async updatedUserAnalyticalMatrixEvaluations(data: Array<AnalyticalMatrixEvaluation>) 
  {
    this.loading = true;
    this.model.analyticalMatrixEvaluations = data;
    
    let dbData = await this.proposalUserReportService.updateReportMatrizEvaluations(this.model.id, this.model);
    this.model.analyticalMatrixEvaluations = dbData.analyticalMatrixEvaluations;
    let goalEvaluations: Array<AnalyticalMatrixEvaluation> = [];

    this.achievedGoals.forEach(goal => {
      let goalEvaluation: AnalyticalMatrixEvaluation = dbData.analyticalMatrixEvaluations.find((x: AnalyticalMatrixEvaluation) => x.especificObjectiveId == goal.id)
      if (goalEvaluation.state == this.pendiente)
        this.canSendEvaluation =  false 
      goalEvaluations.push(goalEvaluation);
    });

    if (!goalEvaluations.some(x => x.state == this.pendiente)) {
      this.canSendEvaluation =  true 
    }

    this.loading = false;
    this.operationSuccess();
  }
}
